<mat-toolbar class="crm-activity-bar">

  <mat-toolbar-row class="crm-activity-bar-row">

    <ng-content> </ng-content>

  </mat-toolbar-row>

</mat-toolbar>
